import React from "react";

function TextWithLineBreaks(props) {
  // Componentes
  if (props && props.text && !props.text.split) {
    return props.text;
  }

  const textWithBreaks = props.text.split("\n").map((text, index) => (
    <React.Fragment key={index}>
      {text}
      <br />
    </React.Fragment>
  ));

  return <div>{textWithBreaks}</div>;
}

export default TextWithLineBreaks;
